import { touchVenueDashboardActivity } from './venueDashboardSession';

const AUTH_RETURN_TO_KEY = 'occasiaAuthReturnTo';

export const saveAuthReturnTo = (path) => {
  if (!path || path === '/') return;
  try {
    sessionStorage.setItem(AUTH_RETURN_TO_KEY, path);
  } catch {
    // ignore storage errors
  }
};

export const consumeAuthReturnTo = () => {
  try {
    const value = sessionStorage.getItem(AUTH_RETURN_TO_KEY);
    sessionStorage.removeItem(AUTH_RETURN_TO_KEY);
    return value || null;
  } catch {
    return null;
  }
};

export const redirectAfterAuth = () => {
  const returnTo = consumeAuthReturnTo();
  if (returnTo && returnTo.startsWith('/')) {
    if (returnTo.startsWith('/venue-dashboard')) {
      touchVenueDashboardActivity();
    }
    window.location.assign(returnTo);
    return true;
  }
  return false;
};
